import { Stack, ToggleButton, ToggleButtonGroup, Tooltip, Typography } from '@mui/material';
import { useProductsTFunction } from '@retail/products/i18n';
import { PackageType } from '@retail/products/types';
import {
  desiredPackagingOrder,
  getClassCodeLabel,
  getPackageTypeLabel,
} from '@retail/products/utils';

interface Props {
  packageTypes: PackageType[];
  selectedPackage: PackageType;
  includeLabel?: boolean;
  setSelectedPackage: (packageType: PackageType) => void;
}

export const PackagesButtonGroup = ({
  packageTypes,
  selectedPackage,
  includeLabel = true,
  setSelectedPackage,
}: Props) => {
  const t = useProductsTFunction();

  const emptyPackages = desiredPackagingOrder.filter((pkg) => !packageTypes.includes(pkg));

  return (
    <Stack direction="row" alignItems="center" gap={6} flexWrap="wrap" p={2}>
      {includeLabel && (
        <Typography variant="body2">{t('products.mgItem.supplierItem.packages')}</Typography>
      )}
      <ToggleButtonGroup
        size="small"
        exclusive
        value={selectedPackage}
        onChange={(_, newView) => newView && setSelectedPackage(newView)}
      >
        {packageTypes.map((packageType) => {
          return (
            <Tooltip key={packageType} title={getPackageTypeLabel(t, packageType)}>
              <ToggleButton value={packageType}>{getClassCodeLabel(packageType)}</ToggleButton>
            </Tooltip>
          );
        })}

        {emptyPackages.map((packaging) => (
          <Tooltip key={packaging} title={getPackageTypeLabel(t, packaging)}>
            <div>
              <ToggleButton value={packaging} disabled>
                {getClassCodeLabel(packaging)}
              </ToggleButton>
            </div>
          </Tooltip>
        ))}
      </ToggleButtonGroup>
    </Stack>
  );
};
